import { List, AutoSizer } from 'react-virtualized';
import { GroupPosition } from '@/configs/apis/groups/interface';
import type { User } from '@/configs/apis/user';
import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import { type Chat } from '@/contexts/chat/scripts/hooks/useChats/types';

function GroupMemberList({
  user,
  memberList,
  onClick,
}: {
  chat: Chat;
  user: User | null;
  memberList: ChatGroupMember[];
  onClick?: (showOpenGroupSetting?: boolean) => void;
}) {
  const rowHeight = 46;

  const rowRenderer = ({
    index,
    style,
  }: {
    index: number;
    style: React.CSSProperties;
  }) => {
    const item = memberList[index];
    return (
      <div style={style} key={item.user_id}>
        <MemberItem
          showCheck={false}
          hoverable
          name={item.user_id === user?.userId ? 'You' : item.name}
          avatarProps={{
            src: item.avatar,
            info: item,
            onClick: () => {
              onClick?.(false);
            },
          }}
          shortName={item.username}
          groupTag={<GroupTag item={item} />}
        />
      </div>
    );
  };

  return (
    <div style={{ flex: 1, minHeight: rowHeight * Math.min(memberList.length, 3) }}>
      <AutoSizer>
        {({ width, height }) => (
          <List
            className="scrollbar_hover"
            width={width}
            height={height}
            rowCount={memberList.length}
            rowHeight={rowHeight}
            rowRenderer={rowRenderer}
          />
        )}
      </AutoSizer>
    </div>
  );
}

export default memo(GroupMemberList);

function GroupTag({ item }: { item: ChatGroupMember }) {
  if (item.role === GroupPosition.Owner) {
    return <Tag color="blue">owner</Tag>;
  }
  if (item.role === GroupPosition.Manager) {
    return <Tag color="green">administrator</Tag>;
  }
  return null;
}
